import React from 'react'
import './Footer.css'
function Footer() {
  return (
    <div className='Footer'>
        <div className='Footer-inner-div'>
        <div className='Footer-div1'>
            <img src='/assets/CopyRights.png'/>
            <p>BuxSwap - All Rights Reserved</p>
        </div>
        <div className='Footer-div2'>
          <a href="https://twitter.com/BuxSwap" target="_blank">
        <img src='/assets/Twitter.png'/>
        </a>
        </div>
        </div>
    </div>
  )
}

export default Footer